<ng-template formLandingHeader></ng-template>
<ng-template formLandingBody [state]="state"></ng-template>
<ng-template formLandingFooter></ng-template>
